module.exports = __webpack_public_path__ + "static/media/41-13.23c042a2.mp3";